import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function CategoryNav({ categories, activeCategory, onSelect, lang }) {
  const { t } = useTranslation();
  const scrollRef  = useRef(null);
  const activeBtnRef = useRef(null);

  // Aktif kategoriye scroll ile ortala
  useEffect(() => {
    if (activeBtnRef.current && scrollRef.current) {
      const container = scrollRef.current;
      const btn       = activeBtnRef.current;
      const offset    = btn.offsetLeft - container.clientWidth / 2 + btn.clientWidth / 2;
      container.scrollTo({ left: offset, behavior: 'smooth' });
    }
  }, [activeCategory]);

  return (
    <nav
      id="category-nav"
      className="sticky top-0 z-40 bg-bistro-dark/95 backdrop-blur-sm border-b border-bistro-border"
      style={{ boxShadow: '0 4px 20px rgba(0,0,0,0.5)' }}
    >
      <div
        ref={scrollRef}
        className="flex gap-1 overflow-x-auto px-3 py-3 max-w-2xl mx-auto"
        style={{ scrollbarWidth: 'none', msOverflowStyle: 'none', WebkitOverflowScrolling: 'touch' }}
      >
        {categories.map((cat) => {
          const isActive = cat.id === activeCategory;
          const label    = cat[`name_${lang}`] || cat.name_pl || cat.name_tr || cat.id;

          return (
            <button
              key={cat.id}
              id={`cat-btn-${cat.id}`}
              ref={isActive ? activeBtnRef : null}
              onClick={() => onSelect(cat.id)}
              className={`
                flex-shrink-0 flex items-center gap-1.5 px-3 py-2 rounded-xl
                font-sans font-medium text-sm transition-all duration-200 ease-out
                whitespace-nowrap
                ${isActive
                  ? 'bg-bistro-gold text-bistro-dark shadow-gold font-semibold'
                  : 'text-bistro-muted hover:text-bistro-cream hover:bg-bistro-surface'
                }
              `}
            >
              <span className="text-base leading-none">{cat.icon}</span>
              <span>{label}</span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
